import GraphContent from "../graph_content";
import moment from "moment";
import { RequestParamsController } from "../../../common/scripts/request_params_controller";
import { AuthStoreType } from "@/types/types";

export class RequestParamsMaker {
  public static makeGetSensorDataParams(self: GraphContent, userID: string) {
    const data = {
      user_id: userID,
      graph_id: self.graphID,
      mst_graph: self.mst_graph,
      auth_store: self.auth_store
    };
    return RequestParamsController.create_v2("post", "getData", data);
  }

  public static makeSearchDataParams(self: GraphContent) {
    const data = {
      user_id: self.userID,
      graph_id: self.graphID,
      auth_store: self.auth_store,
      mst_graph: self.mst_graph,
      search_condition: {
        partition: self.searchPartition,
        attribute: self.searchAttribute,
        fromDate: this.modifyToUtc(self.fromDate, self.dataTimezone),
        toDate: this.modifyToUtc(self.toDate, self.dataTimezone),
        searchType: self.periodType
      }
    };
    return RequestParamsController.create_v2("post", "getPastData", data);
  }

  public static makeDownloadCsvParams(self: GraphContent) {
    const data = {
      user_id: self.userID,
      graph_id: self.graphID,
      auth_store: self.auth_store,
      mst_graph: self.mst_graph,
      search_condition: {
        fromDate: this.modifyToUtc(self.downloadCsvFromDate, self.dataTimezone),
        toDate: this.modifyToUtc(self.downloadCsvToDate, self.dataTimezone),
        partition: self.downloadCsvPartitionKey,
        searchType: self.downloadCsvPeriodType
      }
    };
    return RequestParamsController.create_v2(
      "post",
      "downloadCSVGraphData",
      data
    );
  }

  public static makeKeySchemaParams(self: GraphContent) {
    const data = {
      user_id: self.userID,
      store_name: self.authStoreName,
      table_name: self.inputTableName
    };
    return RequestParamsController.create_v2("post", "getDescribeTable", data);
  }

  public static makeClearUnconfirmedAlert(self: GraphContent) {
    const data = {
      user_id: self.userID,
      graph_id: self.graphID,
      alertHistory: self.alertHistory,
      unconfirmedAlert: self.unconfirmedAlert
    };
    return RequestParamsController.create(
      "post",
      "clearUnconfirmedAlert",
      data
    );
  }

  public static makeGetLatestSensorDataParams(self: GraphContent) {
    const data = {
      mst_graph: self.mst_graph,
      auth_store: self.auth_store
    };
    return RequestParamsController.create_v2("post", "getLatestData", data);
  }

  public static makeAutoUpdateKeysParams(self: GraphContent) {
    const data = {
      mst_graph: self.mst_graph,
      auth_store: self.auth_store
    };
    return RequestParamsController.create_v2("post", "autoUpdateKeys", data);
  }

  public static makeGetSensorKeysParams(self: GraphContent) {
    let authStore;
    self.authStores.map((store: AuthStoreType) => {
      if (self.authStoreName === store.store_name) {
        authStore = store;
      }
    });
    const initMstGraph = {
      table: self.tableName,
      partitionKey: self.partitionKey,
      partitionKeyType: self.partitionKeyType,
      sortKey: self.sortKey,
      sortKeyType: self.sortKeyType,
      timeFormat: self.timeFormat,
      dataTimezone: self.dataTimezone,
      drawRange: self.drawRange,
      partitions: self.partitions,
      attributes: self.attributes
    };
    const data = {
      mst_graph: initMstGraph,
      auth_store: authStore
    };
    return RequestParamsController.create_v2("post", "getSensorKeys", data);
  }

  public static makeSendAlertParams(self: GraphContent, userID: string) {
    const data = {
      user_id: userID,
      graph_id: self.graphID,
      unconfirmedAlert: self.unconfirmedAlert,
      alertHistory: self.alertHistory,
      mails: self.mails.split(",")
    };
    return RequestParamsController.create("post", "sendAlert", data);
  }

  /**
   * date-pickerからくる時刻がPCタイムゾーンに依存しているので、
   * データのタイムゾーンベースにしてからUTC化
   */
  public static modifyToUtc(
    date: string,
    dataTimezone: GraphContent["dataTimezone"]
  ) {
    const pickedData: string = moment(date).format("YYYY-MM-DD HH:mm:ss");
    return moment(pickedData)
      .utcOffset(dataTimezone, true)
      .utc()
      .format("YYYY-MM-DDTHH:mm:ss[Z]");
  }

  /**
   * DynamoDBから最新のお知らせを取得する時のParams
   * @param userName
   */
  public static makePostNoticeDataParams(userName: string) {
    const data = {
      userName
    };
    return RequestParamsController.create_v2("post", "getNotices", data);
  }

  /**
   * お知らせを閉じた時にuserNameをputする時のParams
   */
  public static makePutUserNameParams(userName: string, timestamp: string) {
    const data = {
      userName,
      timestamp
    };
    return RequestParamsController.create_v2("put", "closeNotice", data);
  }
}
